import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from 'xooks';

import authService from 'services/authService';
import { AuthContext } from 'context/AuthContext';
import PageLayout from 'layouts/PageLayout';
import CreatePasswordForm from 'components/forms/CreatePasswordForm';

const ResetPassword = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { setIsNotification } = useContext(AuthContext);
  const { email, token } = useParams();
  const [emailParam, setEmailParam] = useState('');
  const [tokenParam, setTokenParam] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [notification, setNotification] = useState('');

  useDocumentTitle(t('resetPasswordPage.pageTitle'));

  const onClickButtonHandler = async (password) => {
    try {
      await authService
        .createPassword(emailParam, password, password, tokenParam);

      setIsNotification(false);

      history.push('/login');
    } catch (error) {
      setIsNotification(true);

      setNotification(t('notification.createPasswordErrorMessage'));
    }
  };

  useEffect(() => {
    if (email && token && !isLoaded) {
      setEmailParam(email);
      setTokenParam(token);
      setIsLoaded(true);

      history.push('/reset-password');
    }
  }, [location.pathname, email, token,
    history, isLoaded]);

  return (
    <PageLayout>
      <CreatePasswordForm
        title={t('resetPasswordPage.title')}
        passwordLabel={t('resetPasswordPage.passwordLabel')}
        repeatPasswordLabel={t('resetPasswordPage.repeatPasswordLabel')}
        notificationMessage={notification}
        buttonTitle={t('resetPasswordPage.buttonTitle')}
        onClickHandler={onClickButtonHandler}
        notMatchHint={t('notification.passwordsDoNotMatchHint')}
      />
    </PageLayout>
  );
};

export default ResetPassword;
